import http from "../helpers/http-common"

class EmailsService {

    getFilters() {
        return http.get('/emails/filters');
    }

    search(params) {
        return http.post(`/emails/search`, params);
    }

    getStats(params) {
        return http.post(`/emails/stats`, params);
    }

    getEmails(params) {
        return http.post(`/emails/list`, params);
    }
}

export default new EmailsService();